const promoCodeBatchesEndpoints = {
  base: "/v2/cms/promo-code-batches",
  list: ({
    page = 1,
    limit = 20,
    search = "",
    partnerName = "",
    startPointId = "",
  } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 20));
    if (String(search || "").trim()) params.set("search", String(search).trim());
    if (String(partnerName || "").trim()) {
      params.set("partnerName", String(partnerName).trim());
    }
    if (String(startPointId || "").trim()) {
      params.set("startPointId", String(startPointId).trim());
    }
    return `/v2/cms/promo-code-batches?${params.toString()}`;
  },
  byId: (id, { page = 1, limit = 20, status = "all" } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 20));
    params.set("status", String(status || "all"));
    return `/v2/cms/promo-code-batches/${encodeURIComponent(String(id || ""))}?${params.toString()}`;
  },
  exportCsv: (id, status = "all") => {
    const params = new URLSearchParams();
    params.set("status", String(status || "all"));
    return `/v2/cms/promo-code-batches/${encodeURIComponent(String(id || ""))}/export?${params.toString()}`;
  },
  remove: (id) =>
    `/v2/cms/promo-code-batches/${encodeURIComponent(String(id || ""))}`,
};

export default promoCodeBatchesEndpoints;
